import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class AboneTipiListeAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "AboneTipiListe";
        super(baseUrl);
    }


    getAboneTipiListe() {

        return this.get("", false);
    }

}
export default new AboneTipiListeAPI();
